<template>
    <div>
        <Head title="Admin Dashboard" />

        <div class="flex h-screen bg-white overflow-hidden">
            <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
            <!--<div class="lg:hidden">-->
            <!--    <div class="fixed z-40 inset-0 flex">-->
            <!--        &lt;!&ndash;-->
            <!--          Off-canvas menu overlay, show/hide based on off-canvas menu state.-->

            <!--          Entering: "transition-opacity ease-linear duration-300"-->
            <!--            From: "opacity-0"-->
            <!--            To: "opacity-100"-->
            <!--          Leaving: "transition-opacity ease-linear duration-300"-->
            <!--            From: "opacity-100"-->
            <!--            To: "opacity-0"-->
            <!--        &ndash;&gt;-->
            <!--        <div aria-hidden="true" class="fixed inset-0">-->
            <!--            <div class="absolute inset-0 bg-gray-600 opacity-75"></div>-->
            <!--        </div>-->
            <!--        &lt;!&ndash;-->
            <!--          Off-canvas menu, show/hide based on off-canvas menu state.-->

            <!--          Entering: "transition ease-in-out duration-300 transform"-->
            <!--            From: "-translate-x-full"-->
            <!--            To: "translate-x-0"-->
            <!--          Leaving: "transition ease-in-out duration-300 transform"-->
            <!--            From: "translate-x-0"-->
            <!--            To: "-translate-x-full"-->
            <!--        &ndash;&gt;-->
            <!--        &lt;!&ndash;<div class="relative flex flex-1 flex-col pb-4 pt-5 w-full max-w-xs bg-white">&ndash;&gt;-->
            <!--        &lt;!&ndash;    <div class="absolute right-0 top-0 -mr-12 pt-2">&ndash;&gt;-->
            <!--        &lt;!&ndash;        <button class="flex items-center justify-center ml-1 w-10 h-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">&ndash;&gt;-->
            <!--        &lt;!&ndash;            <span class="sr-only">Close sidebar</span>&ndash;&gt;-->
            <!--        &lt;!&ndash;            &lt;!&ndash; Heroicon name: outline/x &ndash;&gt;&ndash;&gt;-->
            <!--        &lt;!&ndash;            <svg aria-hidden="true" class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">&ndash;&gt;-->
            <!--        &lt;!&ndash;                <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />&ndash;&gt;-->
            <!--        &lt;!&ndash;            </svg>&ndash;&gt;-->
            <!--        &lt;!&ndash;        </button>&ndash;&gt;-->
            <!--        &lt;!&ndash;    </div>&ndash;&gt;-->
            <!--        &lt;!&ndash;    <div class="flex flex-shrink-0 items-center px-4">&ndash;&gt;-->
            <!--        &lt;!&ndash;        &lt;!&ndash;Logo&ndash;&gt;&ndash;&gt;-->
            <!--        &lt;!&ndash;    </div>&ndash;&gt;-->
            <!--        &lt;!&ndash;    <div class="flex-1 mt-5 h-0 overflow-y-auto">&ndash;&gt;-->
            <!--        &lt;!&ndash;        <nav class="px-2">&ndash;&gt;-->
            <!--        &lt;!&ndash;            <div class="space-y-1">&ndash;&gt;-->
            <!--        &lt;!&ndash;                &lt;!&ndash; Current: "bg-gray-100 text-gray-900", Default: "text-gray-600 hover:text-gray-900 hover:bg-gray-50" &ndash;&gt;&ndash;&gt;-->
            <!--        &lt;!&ndash;                <a aria-current="page" class="group flex items-center px-2 py-2 text-gray-900 text-base font-medium leading-5 bg-gray-100 rounded-md" href="#">&ndash;&gt;-->
            <!--        &lt;!&ndash;                    &lt;!&ndash; Current: "text-gray-500", Default: "text-gray-400 group-hover:text-gray-500" &ndash;&gt;&ndash;&gt;-->
            <!--        &lt;!&ndash;                    &lt;!&ndash; Heroicon name: outline/home &ndash;&gt;&ndash;&gt;-->
            <!--        &lt;!&ndash;                    <svg aria-hidden="true" class="mr-3 w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">&ndash;&gt;-->
            <!--        &lt;!&ndash;                        <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />&ndash;&gt;-->
            <!--        &lt;!&ndash;                    </svg>&ndash;&gt;-->
            <!--        &lt;!&ndash;                    Home&ndash;&gt;-->
            <!--        &lt;!&ndash;                </a>&ndash;&gt;-->
            <!--        -->
            <!--        &lt;!&ndash;                <a class="group flex items-center px-2 py-2 text-gray-600 hover:text-gray-900 text-base font-medium leading-5 hover:bg-gray-50 rounded-md">&ndash;&gt;-->
            <!--        &lt;!&ndash;                    <svg class="mr-3 w-6 h-6 text-gray-400 group-hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">&ndash;&gt;-->
            <!--        &lt;!&ndash;                        <path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />&ndash;&gt;-->
            <!--        &lt;!&ndash;                    </svg>&ndash;&gt;-->
            <!--        &lt;!&ndash;                    Users&ndash;&gt;-->
            <!--        &lt;!&ndash;                </a>&ndash;&gt;-->
            <!--        -->
            <!--        &lt;!&ndash;                <a class="group flex items-center px-2 py-2 text-gray-600 hover:text-gray-900 text-base font-medium leading-5 hover:bg-gray-50 rounded-md" href="#">&ndash;&gt;-->
            <!--        &lt;!&ndash;                    &lt;!&ndash; Heroicon name: outline/clock &ndash;&gt;&ndash;&gt;-->
            <!--        &lt;!&ndash;                    <svg aria-hidden="true" class="mr-3 w-6 h-6 text-gray-400 group-hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">&ndash;&gt;-->
            <!--        &lt;!&ndash;                        <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />&ndash;&gt;-->
            <!--        &lt;!&ndash;                    </svg>&ndash;&gt;-->
            <!--        &lt;!&ndash;                    Recent&ndash;&gt;-->
            <!--        &lt;!&ndash;                </a>&ndash;&gt;-->
            <!--        &lt;!&ndash;            </div>&ndash;&gt;-->
            <!--        &lt;!&ndash;            <div class="mt-8">&ndash;&gt;-->
            <!--        &lt;!&ndash;                <h3 id="teams-headline" class="px-3 text-gray-500 text-xs font-semibold tracking-wider uppercase">Teams</h3>&ndash;&gt;-->
            <!--        &lt;!&ndash;                <div aria-labelledby="teams-headline" class="mt-1 space-y-1" role="group">&ndash;&gt;-->
            <!--        &lt;!&ndash;                    <a class="group flex items-center px-3 py-2 text-gray-600 hover:text-gray-900 text-base font-medium leading-5 hover:bg-gray-50 rounded-md" href="#">&ndash;&gt;-->
            <!--        &lt;!&ndash;                        <span aria-hidden="true" class="mr-4 w-2.5 h-2.5 bg-indigo-500 rounded-full"></span> <span class="truncate"> Engineering </span>&ndash;&gt;-->
            <!--        &lt;!&ndash;                    </a>&ndash;&gt;-->
            <!--        -->
            <!--        &lt;!&ndash;                    <a class="group flex items-center px-3 py-2 text-gray-600 hover:text-gray-900 text-base font-medium leading-5 hover:bg-gray-50 rounded-md" href="#">&ndash;&gt;-->
            <!--        &lt;!&ndash;                        <span aria-hidden="true" class="mr-4 w-2.5 h-2.5 bg-green-500 rounded-full"></span> <span class="truncate"> Human Resources </span>&ndash;&gt;-->
            <!--        &lt;!&ndash;                    </a>&ndash;&gt;-->
            <!--        -->
            <!--        &lt;!&ndash;                    <a class="group flex items-center px-3 py-2 text-gray-600 hover:text-gray-900 text-base font-medium leading-5 hover:bg-gray-50 rounded-md" href="#">&ndash;&gt;-->
            <!--        &lt;!&ndash;                        <span aria-hidden="true" class="mr-4 w-2.5 h-2.5 bg-yellow-500 rounded-full"></span> <span class="truncate"> Customer Success </span>&ndash;&gt;-->
            <!--        &lt;!&ndash;                    </a>&ndash;&gt;-->
            <!--        &lt;!&ndash;                </div>&ndash;&gt;-->
            <!--        &lt;!&ndash;            </div>&ndash;&gt;-->
            <!--        &lt;!&ndash;        </nav>&ndash;&gt;-->
            <!--        &lt;!&ndash;    </div>&ndash;&gt;-->
            <!--        &lt;!&ndash;</div>&ndash;&gt;-->
            <!--        &lt;!&ndash;<div aria-hidden="true" class="flex-shrink-0 w-14">&ndash;&gt;-->
            <!--            &lt;!&ndash; Dummy element to force sidebar to shrink to fit close icon &ndash;&gt;-->
            <!--        &lt;!&ndash;</div>&ndash;&gt;-->
            <!--    </div>-->
            <!--</div>-->

            <!-- Static sidebar for desktop -->
            <div class="hidden lg:flex lg:flex-shrink-0">
                <div class="flex flex-col pb-4 pt-5 w-64 bg-gray-100 border-r border-gray-200">
                    <div class="flex flex-shrink-0 items-center px-6">
                        <!--LOGO-->
                    </div>
                    <!-- Sidebar component, swap this element with another sidebar if you like -->
                    <div class="flex flex-1 flex-col h-0 overflow-y-auto">
                        <!-- Navigation -->
                        <nav class="mt-6 px-3">
                            <div class="space-y-1">
                                <!-- Current: "bg-gray-200 text-gray-900", Default: "text-gray-700 hover:text-gray-900 hover:bg-gray-50" -->
                                <admin-sidebar-link :active="route().current('admin.dashboard')" :href="route('admin.dashboard')">
                                    <svg aria-hidden="true" class="mr-3 w-6 h-6 text-gray-500 group-hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                    </svg>
                                    Home
                                </admin-sidebar-link>

                                <admin-sidebar-link :active="route().current('admin.users')" :href="route('admin.users')">
                                    <svg class="mr-3 w-6 h-6 text-gray-500 group-hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                    </svg>
                                    Users
                                </admin-sidebar-link>

                                <admin-sidebar-link :active="route().current('admin.posts')" :href="route('admin.posts')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 w-6 h-6 text-gray-500 group-hover:text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                                        />
                                    </svg>
                                    Challenges
                                </admin-sidebar-link>

                                <div>
                                    <hr class="my-3" />
                                </div>

                                <admin-sidebar-link :active="route().current('logout')" :href="route('logout')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 w-6 h-6 text-gray-400 group-hover:text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clip-rule="evenodd" />
                                    </svg>
                                    Logout
                                </admin-sidebar-link>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
            <!-- Main column -->
            <div class="flex flex-1 flex-col w-0 overflow-hidden">
                <!-- Search header -->
                <div class="relative z-10 flex flex-shrink-0 h-16 bg-white border-b border-gray-200 lg:hidden">
                    <!-- Sidebar toggle, controls the 'sidebarOpen' sidebar state. -->
                    <button class="px-4 text-gray-500 border-r border-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500 lg:hidden">
                        <span class="sr-only">Open sidebar</span>
                        <!-- Heroicon name: outline/menu-alt-1 -->
                        <svg aria-hidden="true" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 6h16M4 12h8m-8 6h16" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                        </svg>
                    </button>
                    <div class="flex flex-1 justify-between px-4 sm:px-6 lg:px-8">
                        <div class="flex flex-1">
                            <form action="#" class="flex w-full md:ml-0" method="GET">
                                <label class="sr-only" for="search_field">Search</label>
                                <div class="relative w-full text-gray-400 focus-within:text-gray-600">
                                    <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                                        <!-- Heroicon name: solid/search -->
                                        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path clip-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" fill-rule="evenodd" />
                                        </svg>
                                    </div>
                                    <input
                                        id="search_field"
                                        class="placeholder-gray-500 focus:placeholder-gray-400 block pl-8 pr-3 py-2 w-full h-full text-gray-900 border-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                                        name="search_field"
                                        placeholder="Search"
                                        type="search"
                                    />
                                </div>
                            </form>
                        </div>
                        <!--<div class="flex items-center">-->
                        <!--    &lt;!&ndash; Profile dropdown &ndash;&gt;-->
                        <!--    <div class="relative ml-3">-->
                        <!--        <div>-->
                        <!--            <button id="user-menu" aria-haspopup="true" class="flex items-center max-w-xs text-sm bg-white rounded-full focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2">-->
                        <!--                <span class="sr-only">Open user menu</span>-->
                        <!--                <img alt="" class="w-8 h-8 rounded-full" src="https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=rb-1.2.1&ixqx=WiUzhOBkYi&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" />-->
                        <!--            </button>-->
                        <!--        </div>-->
                        <!--        &lt;!&ndash;-->
                        <!--          Profile dropdown panel, show/hide based on dropdown state.-->

                        <!--          Entering: "transition ease-out duration-100"-->
                        <!--            From: "transform opacity-0 scale-95"-->
                        <!--            To: "transform opacity-100 scale-100"-->
                        <!--          Leaving: "transition ease-in duration-75"-->
                        <!--            From: "transform opacity-100 scale-100"-->
                        <!--            To: "transform opacity-0 scale-95"-->
                        <!--        &ndash;&gt;-->
                        <!--        <div aria-labelledby="user-menu" aria-orientation="vertical" class="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg divide-gray-200 divide-y origin-top-right ring-1 ring-black ring-opacity-5" role="menu">-->
                        <!--            <div class="py-1" role="none">-->
                        <!--                <a class="block px-4 py-2 text-gray-700 hover:text-gray-900 text-sm hover:bg-gray-100" href="#" role="menuitem">View profile</a>-->
                        <!--                <a class="block px-4 py-2 text-gray-700 hover:text-gray-900 text-sm hover:bg-gray-100" href="#" role="menuitem">Settings</a>-->
                        <!--                <a class="block px-4 py-2 text-gray-700 hover:text-gray-900 text-sm hover:bg-gray-100" href="#" role="menuitem">Notifications</a>-->
                        <!--            </div>-->
                        <!--            <div class="py-1" role="none">-->
                        <!--                <a class="block px-4 py-2 text-gray-700 hover:text-gray-900 text-sm hover:bg-gray-100" href="#" role="menuitem">Get desktop app</a>-->
                        <!--                <a class="block px-4 py-2 text-gray-700 hover:text-gray-900 text-sm hover:bg-gray-100" href="#" role="menuitem">Support</a>-->
                        <!--            </div>-->
                        <!--            <div class="py-1" role="none">-->
                        <!--                <a class="block px-4 py-2 text-gray-700 hover:text-gray-900 text-sm hover:bg-gray-100" href="#" role="menuitem">Logout</a>-->
                        <!--            </div>-->
                        <!--        </div>-->
                        <!--    </div>-->
                        <!--</div>-->
                    </div>
                </div>

                <main class="flex-1 focus:outline-none overflow-y-auto" tabindex="0">
                    <!-- Page title & actions -->
                    <div class="px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8 lg:border-b lg:border-gray-200">
                        <div class="flex-1 min-w-0">
                            <h1 class="text-gray-900 text-lg font-medium leading-6 sm:truncate">
                                <portal-target name="header" />
                            </h1>
                        </div>
                        <div class="flex mt-4 sm:ml-4 sm:mt-0">
                            <portal-target name="header-aux" />
                        </div>
                    </div>

                    <!--Main Content-->
                    <section>
                        <slot></slot>
                    </section>
                </main>
            </div>
        </div>
        <portal-target name="overlay" />
    </div>
</template>

<script>
import JetApplicationMark from "@/Jetstream/ApplicationMark"
import JetBanner from "@/Jetstream/Banner"
import JetDropdown from "@/Jetstream/Dropdown"
import JetDropdownLink from "@/Jetstream/DropdownLink"
import JetNavLink from "@/Jetstream/NavLink"
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink"
import AdminSidebarLink from "@/Components/Admin/AdminSidebarLink"

export default {
    components: {
        AdminSidebarLink,

        JetApplicationMark,
        JetBanner,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        JetResponsiveNavLink,
    },

    computed: {
        year() {
            return moment().year()
        },

        hasHeader() {
            return !!this.$slots.header
        },
    },

    data() {
        return {
            showingNavigationDropdown: false,
        }
    },

    methods: {
        switchToTeam(team) {
            this.$inertia.put(
                route("current-team.update"),
                {
                    team_id: team.id,
                },
                {
                    preserveState: false,
                }
            )
        },

        logout() {
            this.$inertia.post(route("logout"))
        },
    },
}
</script>
